export default __webpack_public_path__ + "static/media/pause-white-dark.18827f21.svg";